import { UID } from 'shared/api/query/constants';
import { aggregationConfigChildren } from '@/api/query/nebula/aggregation-config';
import {
  aggregationConfig as aggregationConfigConfig,
  chartGroupBy as chartGroupByConfig,
  coloringRule as coloringRuleConfig,
  goalCycle as goalCycleConfig,
  gridPageTileChart as gridPageTileChartConfig,
  gridPageTile as gridPageTileConfig,
  referenceLine as referenceLineConfig,
} from 'shared/api/query/configs.json';
import { chartGroupByChildren } from '@/api/query/nebula/chart-group-by';
import { coloringMode, coloringRuleOperator, gridPageChartColorScheme, gridPageChartPrecision, optionColor, referenceLineStyle } from 'shared/constants.json';

export const gridPageTileChartChildren = [
  { attr: UID },
  { attr: gridPageTileChartConfig.edges.tile, model: gridPageTileConfig.model, children: [{ attr: UID }] },
  { attr: gridPageTileChartConfig.edges.source },
  { attr: gridPageTileChartConfig.edges.filter, default: null },
  { attr: gridPageTileChartConfig.edges.quickFilters, default: [] },

  { attr: gridPageTileChartConfig.edges.goalCycles, model: goalCycleConfig.model, children: [{ attr: UID }], default: [] },
  { attr: gridPageTileChartConfig.edges.chartType },

  { attr: gridPageTileChartConfig.edges.groupBy, model: chartGroupByConfig.model, children: chartGroupByChildren },
  { attr: gridPageTileChartConfig.edges.aggregationConfig, model: aggregationConfigConfig.model, children: aggregationConfigChildren },
  { attr: gridPageTileChartConfig.edges.excludeNullValues, default: false },
  { attr: gridPageTileChartConfig.edges.stacked, default: true },
  {
    attr: gridPageTileChartConfig.edges.referenceLines,
    model: referenceLineConfig.model,
    children: [
      { attr: UID },
      { attr: referenceLineConfig.edges.value, default: 0 },
      { attr: referenceLineConfig.edges.label, default: '' },
      { attr: referenceLineConfig.edges.style, default: referenceLineStyle.dash },
      { attr: referenceLineConfig.edges.color, default: optionColor.default },
    ],
    default: [],
  },
  { attr: gridPageTileChartConfig.edges.colorScheme, default: gridPageChartColorScheme.automatic },
  { attr: gridPageTileChartConfig.edges.precision, default: gridPageChartPrecision.precisionAutomatic },
  { attr: gridPageTileChartConfig.edges.coloringMode, default: coloringMode.static },
  { attr: gridPageTileChartConfig.edges.color, default: null },
  { attr: gridPageTileChartConfig.edges.metricTitle, default: '' },
  { attr: gridPageTileChartConfig.edges.metricTitleEnabled, default: false },
  {
    attr: gridPageTileChartConfig.edges.coloringRules,
    model: coloringRuleConfig.model,
    children: [
      { attr: UID },
      { attr: coloringRuleConfig.edges.operator, default: coloringRuleOperator.greaterThan },
      { attr: coloringRuleConfig.edges.value, default: 0 },
      { attr: coloringRuleConfig.edges.color, default: optionColor.default },
      { attr: coloringRuleConfig.edges.sortOrder, default: 0 },
    ],
    default: [],
  },
];
